export default function settingsReducer(state = {
    environment: "DEV",
    url_prefix: "",
    pre_redirect_url: "",
    server_email_name: "FleetXPress",
    login_logo: "images/FXP_Logo_Blue.svg",
    logo:"images/DigitalVMS-horizontal_Blue.png",
    nav_logo:"images/autoreach-logo.svg",
    nav_logo_reversed: "images/dvms-logo.png",
    application_success_logo: 'images/OEM-DVMS-Logo.png',
    oem_success_logo: 'images/OEM-DVMS-Logo.png',
    oem_colour: '#265BFF',
    vehicle_type: 'cars',
    vehicle_usage_types: {},
    vehicle_options: {
        'engine': {},
        'transmission': {},
        'drive_train': {}, 
        'tires': {},
        'exterior': {},
        'interior': {},
        'body_type': {},
        'roof': {}
    },
    vehicle_details: {
        'trans_opt': [],
        'engine_opt': [],
        'drive_train_opt': [],
        'roof_opt': [],
        'tires_opt': [],
        'body_style_opt': [],
        'fuel_opt': []
    },
    images: {
        'vehicle_placeholder': 'images/vehicle/vehicle-img-empty.png',
        'vehicle_placeholder_square': 'images/vehicle/vehicle-img-empty-square.png',
        'vehicle_placeholder_empty': 'images/emptystate-icons/Vehicle_Inactive.svg',
    }
}, action) {
    switch(action.type) {
        case "SET_ENVIRONMENT" :{
            return state = {
                ...state,
                environment: action.payload.environment,
                url_prefix: action.payload.url_prefix
            }
        }

        case "SET_PRE_REDIRECT_URL" :{
            return state = {
                ...state,
                pre_redirect_url: action.payload
            }
        }

        case "SET_LOGOS" :{
            return state = {
                ...state,
                login_logo: action.payload.login_logo,
                logo: action.payload.logo,
                nav_logo: action.payload.nav_logo,
                server_email_name: action.payload.server_email_name
            }
        }

        case "SET_OEM_SPECIFIC" :{
            return state = {
                ...state,
                server_email_name: action.payload.server_email_name,
                login_logo: action.payload.login_logo,
                logo: action.payload.logo,
                nav_logo: action.payload.nav_logo,
                nav_logo_reversed: action.payload.nav_logo_reversed,
                application_success_logo: action.payload.application_success_logo,
                oem_success_logo: action.payload.oem_success_logo,
                oem_colour: action.payload.oem_colour,
                vehicle_usage_types: action.payload.vehicle_usage_types,
                vehicle_type: action.payload.vehicle_type,
                vehicle_options: action.payload.vehicle_options,
                vehicle_details: action.payload.vehicle_details,
                images: action.payload.images
            }
        }

        default: {

        }
    }

    return state;
}